export const FIELDS = {

  ID: 'id',
  SOURCE_ID: 'sourceId',
  REFERENCE_ID: 'referenceId',
  ACCOUNT_ID: 'accountId',
  AMOUNT: 'amount',
  DESCRIPTION: 'description',
  EXPENSE_DATE: 'expenseDate',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  SOURCE_NAME: 'sourceName',
  ACCOUNT_NAME: 'accountName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};